import { PAYER_PROFILE_CONSENT_VERSION, type PayerProfile, type PayerProfileSetup } from "@shyne/shared/api";
import { api } from "@/lib/api";
import { activeOrganizationId } from "@/lib/active-organization";

export type { PayerProfile, PayerProfileSetup };

export function formatPayerMethodSummary(profile: PayerProfile | null): string {
  if (!profile?.paymentMethodType || !profile.last4) {
    return "No payment method saved";
  }

  const name = profile.brandOrBankName?.trim();
  if (profile.paymentMethodType === "card") {
    const brand = name || "Card";
    const expiry = profile.expMonth && profile.expYear ? `, expires ${profile.expMonth}/${profile.expYear}` : "";
    return `${brand} ending in ${profile.last4}${expiry}`;
  }

  return `${name || "Bank account"} ending in ${profile.last4}`;
}

const acting = () => ({ actingOrganization: activeOrganizationId() });

export async function getPayerProfile(): Promise<PayerProfile | null> {
  return (await api.payerProfile.get(acting())).profile;
}

export function createPayerSetupIntent(): Promise<PayerProfileSetup> {
  return api.payerProfile.setUp(acting());
}

export function finalizePayerSetup(setupIntent: string): Promise<PayerProfile> {
  return api.payerProfile.finalize({ ...acting(), setupIntent, consentAccepted: true, consentVersion: PAYER_PROFILE_CONSENT_VERSION });
}

export async function deletePayerProfile(): Promise<void> {
  await api.payerProfile.remove(acting());
}
